import React from "react";
import "./InternalDebuggerRelationshipView.scss";
import type { Relationship } from "@packages/commons";

export interface DebuggerRelationshipViewProps {
  id: string;
  relationships: Relationship[];
  current?: boolean;
}

const DebuggerRelationshipView = (props: DebuggerRelationshipViewProps) => {
  const { id, relationships, current } = props;

  const relationship = relationships.find((rel) => rel.id === id);

  if (!relationship) {
    return <span>Relationship not found: {id}</span>;
  }

  return (
    <div className={`RelationshipView ${current ? "--current" : ""}`}>
      <div>
        <strong>{relationship.name || relationship.id}</strong>
      </div>
      {relationship.source && relationship.target && (
        <div>
          {relationship.source} → {relationship.target}
        </div>
      )}
      {relationship.text && <div>{relationship.text}</div>}
      {relationship.textSingular && <div>{relationship.textSingular}</div>}
    </div>
  );
};

export default DebuggerRelationshipView;
